import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ManagedHttpContext } from '@osos/shared/types';
import { Observable } from 'rxjs';
import { UserPreferencesState } from '../../state';

const DELEGATION_ID_HEADER_NAME = 'X-Delegation-Id';
@Injectable()
export class DelegationInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const httpContext = ManagedHttpContext.create(request.context);
    if (httpContext.bypassDelegationMiddleware) {
      return next.handle(request);
    }

    const activeDelegation = this.store.selectSnapshot(
      UserPreferencesState.activeDelegationId,
    );
    if (!activeDelegation) {
      return next.handle(request);
    }

    const headers = {
      [DELEGATION_ID_HEADER_NAME]: `${activeDelegation}`,
    };

    const newRequest = request.clone({
      setHeaders: headers,
    });

    return next.handle(newRequest);
  }
}
